import { css, SerializedStyles } from '@emotion/core'
import * as React from 'react'

import { breakpoints } from '../../constants/breakPoints'
import { isMobile } from '../../helpers/common'
import { useBlackBG } from '../../hooks/useBlackBG'

interface RichTextAssetBlockProps {
  className?: string
  children: React.ReactNode
  withoutPadding?: boolean
  cssStyles?: SerializedStyles
}

const RichTextAssetBlock: React.FunctionComponent<RichTextAssetBlockProps> = ({
  className,
  children,
  withoutPadding = false,
  cssStyles = css``,
}) => {
  const blackBG = useBlackBG()

  return (
    <div
      className={`${className} ${isMobile(breakpoints.small) ? 'full-screen-relative' : ''}`}
      css={[assetContainerStyle(blackBG), cssStyles]}
    >
      <div className={'quote-content-container'} css={assetContentStyle(withoutPadding, blackBG)}>
        {children}
      </div>
    </div>
  )
}

export default RichTextAssetBlock

const assetContainerStyle = (blackBG: boolean) => css`
  border-radius: 0.5rem;
  margin: 2rem 0;
  padding: 2rem;
  background-color: rgba(173, 230, 255, ${blackBG ? 0.1 : 0.22});

  @media screen and (max-width: ${breakpoints.small}px) {
    margin: 2rem -1.5rem;
    padding: 1.5rem;
    border-radius: 0;
  }
`

const assetContentStyle = (withoutPadding: boolean, blackBG: boolean) => css`
  border-radius: 0.5rem;
  background-color: ${withoutPadding ? 'transparent' : blackBG ? 'rgba(57, 66, 78, 0.8)' : '#fff'};
  overflow: hidden;
  box-shadow: ${withoutPadding ? 'none' : `rgba(5, 140, 232, ${blackBG ? 0.2 : 0.1}) 0 0 20px`};
  ${!withoutPadding && 'padding: 2rem;'};

  @media screen and (max-width: ${breakpoints.small}px) {
    ${!withoutPadding && 'padding: 1.5rem;'};
  }
`
